// used for when data in select boxes are dependent on other select boxes


bq.selectboxLink = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.selects   = [];
};

bq.selectboxLink.DEFAULTS = {
  selectBox: ".select-link",
  configBox: ".configurable-attribute",
  managePrice: true,
  priceTemplate: '(%s)',
  mainSelect: 0 //first one drive all others, is never blank
};

bq.selectboxLink.prototype = {
  init: function() {
    bq.debug.log("Selectbox Link : init()", this.$element);

    this.loadSelects();

    if(this.options.managePrice) {
      this.updatePrice();
    }

    this.updateSelects(this.selects[this.options.mainSelect].box);


    $(this.options.selectBox, this.$element).on('change', {thiz:this}, this.catchSelectChange);
  },

  updatePrice: function() {
    var $this = this;
    $.each(this.selects, function(key, select) {
      var $price = select.currentPrice;
      $.each(select.options, function(index, option) {
        var el = option.option;

        if(option.value) {
          var val = '';
          if($price == option.price) {
            val = option.text;
          } else if($price > option.price) {
            val = option.text + ' ' + $this.options.priceTemplate.replace("%s", '-'+accounting.formatMoney($price - option.price));
          } else {
            val = option.text + ' ' + $this.options.priceTemplate.replace("%s", '+'+accounting.formatMoney(option.price - $price));
          }
          el.text(val);
        }
      });
    });
  },

  loadSelects: function() {
    var $this = this;

    $.each($(this.options.selectBox, this.$element), function() {
      var el = $(this);
      var options = [];

      $.each(el.find('option'), function(){
        var $option = $(this);
        var tmpData = $.extend({option: $option, value: $option.attr('value'), text: $option.text()}, $option.data());
        options.push(tmpData);
      });

      $this.selects.push({
        box: el,
        options: options,
        currentPrice: 0
      });
    });
  },

  updateSelects: function(updatedSelect) {
    var clear = false;
    var value = updatedSelect.val();
    var $this = this;
    var showOnly = [];

    $.each(this.selects, function(key, select) {
      if(updatedSelect.is(select.box)) {
        var option = false;
        if(value !== '') {
          $.each(select.options, function(opt){
            if(opt.value == value) { option = opt; $.merge(showOnly, opt.link); }
          });

          if($this.options.managePrice) {
            var price = option.price;
            select.currentPrice = price ? price : 0;
          }
        } else {
          select.currentPrice = 0;
        }
        if(!$(select.box).hasClass('configurable-attribute')) {
          clear = true; //lets clear all boxes after this one
        }
      } else {
        if(clear) {
          select.box.val('');
          $this.throwEventUpdatePrice(select.box);
          select.currentPrice = 0;
          select.box.find('option').remove();

          $.each(select.options, function(index, opt){
            var add = false;
            if(opt.value === '') {
              add = true;
            } else {
              $.each(opt.link, function(i){
                if($.inArray(i, showOnly) !==-1) {
                  add = true;
                }
              });
            }

            if(add) {
              select.box.append(opt.option);
            }

          });

          select.box.val('');

        } else {
          var $val = select.box.val();
          if($val !== '') {
            $.each(select.options, function(opt){
              if(opt.value == $val) { $.merge(showOnly, opt.link); }
            });
          }
        }
      }
    });

    if(this.options.managePrice) {
      this.updatePrice();
    }

  },

  catchSelectChange: function(e) {
    bq.debug.log("Selectbox Link : event caught : select change", e);

    var $this = e.data.thiz;

    $this.updateSelects($(e.target));
  },

  throwEventUpdatePrice: function(el) {
    bq.debug.log("Selectbox Link : event thrown [bq.productPrice.update]", this.totalPages, this.currentPage);

    //throws trigger (e, el)
    this.$element.trigger('bq.productPrice.update', [el]);
  }

};

// SELECTBOX LINK PLUGIN DEFINITION
// =======================

var selectboxLinkold = $.fn.selectboxLink;

$.fn.selectboxLink = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.selectboxLink');
    var options = $.extend({}, bq.selectboxLink.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.selectboxLink', (data = new bq.selectboxLink(this, options))); }
    data.init();
  });
};

$.fn.selectboxLink.Constructor = bq.selectboxLink;

// SELECTBOX LINK NO CONFLICT
// =================

$.fn.selectboxLink.noConflict = function () {
  $.fn.selectboxLink = selectboxLinkold;
  return this;
};

// SELECTBOX LINK DATA-API
// ==============

bq.selectboxLinkInit = function() {
  $('[data-bq="selectbox-link"]').each(function () {
    var el = $(this);
    if(el.data('bq.selectboxLink')) { return; }
    el.selectboxLink(el.data());
  });
};

bq.init.push(bq.selectboxLinkInit);

